import React, { useState, useRef, useContext, useMemo } from 'react';

//bs
//import { FormGroup, FormFeedback, Input, Label, Button } from 'reactstrap';
import { Button } from 'reactstrap';

//form
import { Formik, Form } from 'formik';
//import * as Yup from 'yup';

//comps
import LoadingLayer from 'components/loaders/LoadingLayer';
import { showGlobalAlert } from 'context/AlertContext';
import ModalBase from 'components/modals/ModalBase';

//images
import Close from 'css/images/close.svg';

//api
import * as mainApi from 'api/mainApi';

//context
import { UserContext } from 'context/UserContext';

const CatalogOrderModal = ({ toggle, product }) => {
	const formikRef = useRef();
	const containerRef = useRef();
	const [isLoading, setIsLoading] = useState(false);
	const { userData, setUserData } = useContext(UserContext);

	//------------------------

	const initialValues = useMemo(
		() => ({
			order_name: '',
			order_surname: '',
			direction: '',
			phone: '',
			postal_code: '',
			city: '',
			province: '',
			product_id: product.id,
		}),
		[product.id],
	);

	// const validationSchema = useMemo(
	// 	() =>
	// 		Yup.object().shape({
	// 			order_name: Yup.string().required('El nombre es obligatorio'),
	// 			order_surname: Yup.string().required('Los apellidos son obligatorios'),
	// 			direction: Yup.string().required('La dirección es obligatoria'),
	// 			phone: Yup.string()
	// 				.required('El teléfono es obligatorio')
	// 				.matches(/^\d{9}$/, 'El teléfono debe tener 9 dígitos sin espacios'),
	// 			postal_code: Yup.string()
	// 				.required('El código postal es obligatorio')
	// 				.matches(/^\d{5}$/, 'El código postal debe tener 5 dígitos'),
	// 			city: Yup.string().required('La ciudad es obligatoria'),
	// 			province: Yup.string().required('La provincia es obligatoria'),
	// 			product_id: Yup.string().required('El producto es obligatorio'),
	// 		}),
	// 	[],
	// );
	//------------------------

	const handleSubmitForm = async (formValues) => {
		setIsLoading(true);
		const data = await mainApi.sendCatalogOrder(formValues);
		if (data && data.succeded) {
			showGlobalAlert(null, null, true);
			setUserData((prev) => ({ ...prev, points: data.newPoints }));
			toggle();
		} else {
			showGlobalAlert(
				'¡Ups!',
				data.message || 'Inténtalo de nuevo en unos minutos.',
			);
		}
		setIsLoading(false);
	};

	//------------------------
	const scrollToFirstError = (errors) => {
		if (!containerRef.current || Object.keys(errors).length === 0) return;
		requestAnimationFrame(() => {
			if (!containerRef.current) return;
			const firstError = containerRef.current.querySelector('.has-error');
			if (!firstError) return;
			const modal = firstError.closest('.modal');
			if (!modal) return;
			const top =
				firstError.getBoundingClientRect().top -
				modal.getBoundingClientRect().top +
				modal.scrollTop -
				80;
			modal.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
		});
	};

	return (
		<ModalBase isOpen={true} toggle={toggle} containerClass="order-form-modal">
			<Formik
				innerRef={formikRef}
				initialValues={initialValues}
				//validationSchema={validationSchema}
				validateOnBlur={false}
				validateOnChange={false}
				onSubmit={handleSubmitForm}
			>
				{({ errors, submitCount, submitForm }) => (
					<Form autoComplete="off" id="full-form-anchor">
						<LoadingLayer visible={isLoading} />
						<div className="alert-header">
							<div className="head-deco">
								<img src={Close} onClick={toggle} alt="Cerrar" />
							</div>
						</div>
						<div className="container-step-1" ref={containerRef}>
							<div className="tit">CONFIRMACIÓN DE DATOS DE ENVÍO</div>
							<p>
								El premio seleccionado se enviará a tu concesionario asociado.
								Una vez confirmado el pedido se descontarán los puntos
								correspondientes a tu cuenta.
							</p>
							<div className="order-summary">
								<div className="order-summary__row">
									<strong>{userData?.concesionario?.nombre}</strong>
								</div>
								<div className="order-summary__row">
									Dirección: {userData?.concesionario?.calle}{' '}
									{userData?.concesionario?.numero},{' '}
									{userData?.concesionario?.ciudad}
								</div>
								<div className="order-summary__row">
									ATT: {userData?.name} {userData?.ape1} {userData?.ape2}
								</div>
								<div className="order-summary__row">
									Teléfono: {userData?.telef}
								</div>
							</div>

							{/* <FormGroup>
							<Label for="order_name">Nombre</Label>
							<Input
								tag={Field}
								name="order_name"
								id="order_name"
									type="text"
									placeholder="Introduce tu nombre"
									className={errors.order_name && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.order_name && submitCount > 0 && (
									<FormFeedback>{errors.order_name}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="order_surname">Apellidos</Label>
								<Input
									tag={Field}
									name="order_surname"
									id="order_surname"
									type="text"
									placeholder="Introduce tus apellidos"
									className={errors.order_surname && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.order_surname && submitCount > 0 && (
									<FormFeedback>{errors.order_surname}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="direction">Dirección completa</Label>
								<Input
									tag={Field}
									name="direction"
									id="direction"
									type="text"
									placeholder="Introduce tu dirección completa"
									className={errors.direction && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.direction && submitCount > 0 && (
									<FormFeedback>{errors.direction}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="postal_code">Código postal</Label>
								<Input
									tag={Field}
									name="postal_code"
									id="postal_code"
									type="text"
									placeholder="Introduce tu código postal"
									className={errors.postal_code && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.postal_code && submitCount > 0 && (
									<FormFeedback>{errors.postal_code}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="city">Población</Label>
								<Input
									tag={Field}
									name="city"
									id="city"
									type="text"
									placeholder="Introduce tu población"
									className={errors.city && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.city && submitCount > 0 && (
									<FormFeedback>{errors.city}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="province">Provincia</Label>
								<Input
									tag={Field}
									name="province"
									id="province"
									type="text"
									placeholder="Introduce tu provincia"
									className={errors.province && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.province && submitCount > 0 && (
									<FormFeedback>{errors.province}</FormFeedback>
								)}
							</FormGroup>
							<FormGroup>
								<Label for="phone">Número de teléfono</Label>
								<Input
									tag={Field}
									name="phone"
									id="phone"
									type="text"
									placeholder="Introduce tu número de teléfono"
									className={errors.phone && submitCount > 0 ? 'has-error' : ''}
								/>
								{errors.phone && submitCount > 0 && (
									<FormFeedback>{errors.phone}</FormFeedback>
								)}
							</FormGroup> */}
							<div className="text-center">
								<Button
									type="button"
									color="send"
									className="mt-3 mb-4"
									onClick={() => {
										submitForm().then(() => scrollToFirstError(errors));
									}}
								>
									CONFIRMAR PEDIDO
								</Button>
							</div>
							<div className="legal-disc">
								<p>
									*Al canjear tus puntos, aceptas que Mazda Automóviles España,
									S.A. use tus datos para todos y cada uno de los siguientes
									fines: la elaboración de perfiles comerciales y la realización
									-por cualquier medio de los facilitados- de labores
									comerciales relacionadas con promociones, vehículos y/o
									servicios prestados por Mazda o su red de concesionarios.
									Asimismo, aceptas que tus datos sean cedidos para la misma
									finalidad a las empresas de su grupo. Derechos: Si deseas
									ejercer tus derechos de acceso, rectificación, suspensión,
									oposición y cualquier otro derecho que te corresponda en
									relación con tus datos, contacta con nosotros por correo
									postal: Mazda Automóviles España. C/Manuel Pombo Angulo 28, 2º
									planta- 28050 Madrid, o por email: privacidad@mazdaeur.com.
									Para más información sobre la Protección de Datos de Mazda
									Automóviles España.
								</p>
								<p>
									Asimismo, le recordamos que puede retirar y modificar sus
									opciones de consentimiento respecto de cookies y tecnologías
									similares en el centro de preferencias de privacidad, así como
									consultar la política de privacidad vigente.
								</p>
							</div>
						</div>
					</Form>
				)}
			</Formik>
		</ModalBase>
	);
};

export default CatalogOrderModal;
